module.exports = __webpack_public_path__ + "img/Painting04.9c4083f3.png";